import React from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const CustomParagraph = ({ text, htmlString, level, color, strong, fontSize, lineHeight, marginBottom, marginTop, fontWeight, textAlign, whiteSpace , ellipsis=false, noText="", style = {}, className }) => {
  if (htmlString) {
    const divStyle = {
      color: color,
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontWeight: fontWeight,
      marginBottom: marginBottom,
      marginTop: marginTop,
      textAlign: textAlign,
      whiteSpace: whiteSpace, // Keep this for potential newline/whitespace handling in the generated HTML
      ...style, // Allow overriding with explicit style prop
    };
    return (
      <div
        className={className}
        style={divStyle}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    );
  }

  // For plain text rendering, use all original props including ellipsis, level, strong
  return (
    <Paragraph className={className} ellipsis={ellipsis} level={level} strong={strong} style={{ color: color, marginTop: marginTop , fontSize: fontSize, lineHeight: lineHeight, fontWeight: fontWeight, marginBottom: marginBottom, textAlign: textAlign , whiteSpace:'pre-line', overflowWrap: 'break-word', ...style, }}>
      {text ? text : noText}
    </Paragraph>
  );
};

export default CustomParagraph;